import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { RootState, setItemDetectionConfirmed } from "@/store";
import { useTimeTracking } from "@/contexts/TimeTrackingContext";
import {
  hasQuestionOneAnswer,
  getShowNoLocationRequired,
} from "@/utils/helpers";

export const useItemDetectionQuestion = () => {
  const dispatch = useAppDispatch();
  const { recordQ2Interaction } = useTimeTracking();
  const emptyAreaConfirmed = useAppSelector(
    (state: RootState) => state.oos.emptyAreaConfirmed,
  );
  const itemDetectionConfirmed = useAppSelector(
    (state: RootState) => state.oos.itemDetectionConfirmed,
  );
  const resultMetadata = useAppSelector(
    (state: RootState) => state.oos.resultMetadata,
  );

  const questionOneHasAnswer = hasQuestionOneAnswer(
    emptyAreaConfirmed,
    resultMetadata,
  );
  const showNoLocationRequired = getShowNoLocationRequired(
    emptyAreaConfirmed,
    resultMetadata,
  );

  const handleItemDetectionConfirmedChange = (value: string) => {
    recordQ2Interaction();
    dispatch(setItemDetectionConfirmed(value === "yes"));
  };

  return {
    itemDetectionConfirmed,
    questionOneHasAnswer,
    showNoLocationRequired,
    handleItemDetectionConfirmedChange,
  };
};
